<capra-toast type="success" [inline]="true" [canTapToDismiss]="false">
  <div class="feedback-toast-content">
    <div class="toast-body">
      <h4 class="title">Marked helpful.</h4>
      <p class="success-message">Thanks for improving AI Assist!</p>
    </div>
  </div>
</capra-toast>
